'use client';
import React from 'react';
import { Link } from 'react-router-dom';
import { TruckIcon, GlobeAltIcon, BuildingOffice2Icon, CubeIcon } from '@heroicons/react/24/outline';

const services = [
    {
        title: 'National Drayage',
        description: 'Import & export drayage execution from both rail and port, with over 300 power units and 1,500 chassis via JCT.',
        icon: TruckIcon,
        image: '/images/drayage.jpg'
    },
    {
        title: 'Transloading',
        description: 'Efficient transloading services with strategic pre-pull, secure storage, and grounding solutions.',
        icon: BuildingOffice2Icon,
        image: '/images/transloading1.jpg'
    },
    {
        title: 'Warehousing',
        description: 'Dedicated yard operations and secure storage solutions with modern inventory management systems.',
        icon: CubeIcon,
        image: '/images/warehousing1.jpg'
    },
    {
        title: 'Domestic FTL',
        description: 'National capacity via own assets & collaboration with trusted partners for reliable full truckload services.',
        icon: GlobeAltIcon,
        image: '/images/ftl1.jpg'
    }
];

const Services = () => {
    return (
        <section className="section-padding bg-[var(--background-light)]">
            <div className="max-w-7xl mx-auto container-padding">
                <div className="text-center mb-16 animate__animated animate__fadeIn">
                    <div className="section-title bg-[#29abe2] bg-opacity-10">
                        <span className="section-title-text">Our Services</span>
                    </div>
                    <h2 className="heading-secondary">
                        Our Logistics Services
                    </h2>
                    <p className="text-lg text-[var(--text-secondary)] max-w-2xl mx-auto">
                        We offer comprehensive logistics solutions with a focus on drayage, transloading, warehousing, and FTL services.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {services.map((service, index) => {
                        const Icon = service.icon;
                        return (
                            <Link
                                key={index}
                                to={`/services#${service.title.toLowerCase().replace(/\s+/g, '-')}`}
                                className="bg-white rounded-xl shadow-sm overflow-hidden card-hover animate__animated animate__fadeInUp"
                                style={{ animationDelay: `${index * 0.2}s` }}
                            >
                                <div className="relative h-48 overflow-hidden group">
                                    <img
                                        src={service.image}
                                        alt={service.title}
                                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                                    <div className="absolute top-6 left-6 bg-white/90 p-3 rounded-lg backdrop-blur-sm">
                                        <Icon className="h-6 w-6 text-[var(--primary-color)]" />
                                    </div>
                                </div>
                                <div className="p-6">
                                    <h3 className="text-xl font-semibold text-[var(--text-primary)] mb-3">
                                        {service.title}
                                    </h3>
                                    <p className="text-[var(--text-secondary)] mb-4">
                                        {service.description}
                                    </p>
                                    <div className="text-[var(--primary-color)] font-medium hover:text-[var(--primary-dark)] transition-colors duration-300 group">
                                        Learn More 
                                        <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>

                <div className="mt-16 text-center animate__animated animate__fadeInUp animate__delay-1s">
                    <Link to="/services" className="btn-primary">
                        View All Services
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Services; 